import { indefiniteArticle } from './indefiniteArticle';
const formatters = {
    indefiniteArticle
};
export const customFormatters = {
    type: '3rdParty',
    init: (instance)=>{
        if (instance.services.formatter) {
            for (const [formatterName, formatterFunction] of Object.entries(formatters)){
                instance.services.formatter.add(formatterName, formatterFunction);
            }
        }
    }
};

//# sourceMappingURL=index.js.map